import React, { useState, useEffect, useContext } from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useFilters,
} from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ExpandableTable.css";
import Sortdownarrow from "../../IconComponents/Sortdownarrow";
import Sortuparrow from "../../IconComponents/Sortuparrow";
import Sortingarrow from "../../IconComponents/Sortingarrow";
import TableHeader from "./TableHeader/TableHeader";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { Button, Modal } from "react-bootstrap";
import { XCircleblack } from "../../IconComponents"; 
import { ThemeContext } from "../../..";

// Default filter UI for a column
const DefaultColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter },
}) => {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // undefined to remove the filter entirely
      }}
      placeholder={`Filter...`}
      style={{
        width: "100%",
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        marginTop: "5px",
      }}
    />
  );
};

const Expandaletable = (props) => {
  const {
    columns,
    data,
    numberOfRows,
    headerTableHeadStyle = {},
    tableStyle = {},
    showRowCount = true,
    rowCount,
    tabChanger = false,
    activeTab,
    setActiveTab,
    searchData,
    setSearchData = () => {},
    enableColumnFilters = false,
    disbalePaginationFilter = false,
    disbalePaginationFilter1 = false,
    disbalePaginationFilter2 = false,
  } = props;

  const [expandedRowIds, setExpandedRowIds] = useState({});
  const { theme } = useContext(ThemeContext);
  const [showRegionModal, setShowRegionModal] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState("");

  const [showActionModal, setShowActionModal] = useState(false);
const [selectedAction, setSelectedAction] = useState("");

const handleActionClick = (message) => {
  setSelectedAction(message);
  setShowActionModal(true);
};

const handleActionModalClose = () => {
  setShowActionModal(false);
  setSelectedAction("");
};

  const handleRegionClick = (region) => {
    setSelectedRegion(region);
    setShowRegionModal(true);
  };

  const handleRegionModalClose = () => {
    setShowRegionModal(false);
    setSelectedRegion("");
  };

  const toggleRowExpansion = (rowId) => {
    setExpandedRowIds((prev) => {
      const isCurrentlyExpanded = !!prev[rowId];
      return isCurrentlyExpanded ? {} : { [rowId]: true };
    });
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    rows,
    state: { pageIndex, globalFilter, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: { pageIndex: 0, pageSize: numberOfRows },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { t } = useTranslation();

  const translateNumber = (number) => {
    const numberString = number.toString();
    return i18n.t(`numbers.${numberString}`, { defaultValue: numberString });
  };

  let tempRowCount = globalFilter ? rows.length : rowCount || data.length;
  let tempPageIndex = pageIndex;
  let tempPageSize = pageSize;

  if (tempPageIndex === undefined || tempPageIndex === null) {
    tempPageIndex = 0;
  }
  if (tempRowCount === undefined || tempRowCount === null) {
    tempRowCount = 0;
  }
  if (tempPageSize === undefined || tempPageSize === null) {
    tempPageSize = 10;
  }

  const startIndex = tempPageIndex * tempPageSize + 1 || 1;
  const endIndex =
    Math.min((tempPageIndex + 1) * tempPageSize, tempRowCount) || tempRowCount;

  const translatedStartIndex = startIndex;
  const translatedEndIndex = endIndex;
  const translatedRowCount = tempRowCount;

  useEffect(() => {
    setPageSize(numberOfRows);
  }, [numberOfRows]);

  useEffect(() => {
    if (globalFilter) {
      const pageData = page?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    } else {
      const pageData = rows?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    }
  }, [globalFilter, rows]);

  const renderExpandedRow = (row) => {
    const userTaskMap = row.original.userTaskMapList || [];

    return (
      <tr>
        <td colSpan="6">
          <div
            style={{
              width: "85%",
              border: "1px solid white",
              borderRadius: "10px",
              marginTop: "10px",
              marginLeft: "80px",
              marginBottom: "10px",
              border: "1px solid #ddd",
            }}
          >
            <table
              style={{
                height: "5%",
                borderCollapse: "collapse",
                position: "relative",
              }}
            >
              <thead style={{ position: "sticky" }}>
                <tr style={{ backgroundColor: "#f5f5f5" }}>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Assign To")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Region")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Action Message")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Updated On")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Status")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {userTaskMap.map((task) => (
                  <tr key={task.id}>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.assigned_to || t("NA")}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                        cursor: "pointer",
                        color: "#18A3A0",
                        textDecoration: "underline",
                      }}
                      title={task.region_name || t("NA")}
                      onClick={() =>
                        handleRegionClick(task.region_name || t("NA"))
                      }
                    >
                      {task.region_name?.length > 10
                        ? `${task.region_name.substring(0, 10)}...`
                        : task.region_name || t("NA")}
                    </td>
                    <td
  style={{
    padding: "8px",
    textAlign: "left",
    borderBottom: "1px solid gray",
    cursor: "pointer",
  }}
  title={task.action_message || t("NA")}
  onClick={() => handleActionClick(task.action_message || t("NA"))}
>
  {task.action_message?.length > 25
    ? `${task.action_message.substring(0, 25)}...`
    : task.action_message || t("NA")}
</td>
                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.updated_on
                        ? new Date(task.updated_on).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                        : t("NA")}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.task_status_code ? (
                        task.task_status_code === "TASK_EXE_STATUS_NEW_TASK" ? (
                          <div className="inactivestatus">
                            <div id="inactive_dot"></div>
                            <div>
                              {t(
                                task.task_type === 1
                                  ? "New Message"
                                  : "New Task"
                              )}
                            </div>
                          </div>
                        ) : task.task_status_code ===
                          "TASK_EXE_STATUS_INPROGRESS" ? (
                          <div className="inprogressstatus">
                            <div id="progress_dot"></div>
                            <div>{t("In Progress")}</div>
                          </div>
                        ) : task.task_status_code ===
                          "TASK_EXE_STATUS_COMPLETED" ? (
                          <div className="activestatus">
                            <div id="active_dot"></div>
                            <div>
                              {t(
                                task.task_type === 1
                                  ? "Acknowledged"
                                  : "Completed"
                              )}
                            </div>
                          </div>
                        ) : task.task_status_code ===
                          "TASK_EXE_STATUS_INPROGRESS_SOMEONE" ? (
                          <div className="startedbysomeone">
                            <div id="someone_dot"></div>
                            <div>{t("Task started by someone")}</div>
                          </div>
                        ) : (
                          t("NA")
                        )
                      ) : (
                        t("NA")
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <div className="tabl_container">
      <TableHeader
        {...props}
        searchValue={globalFilter || ""}
        onSearchHandler={setGlobalFilter}
      />
      <div className="iccc__table--container" style={tableStyle}>
        <table {...getTableProps()} className="table iccc--table">
          <thead>
            <tr>
              <th
                style={{
                  width: "30px",
                  textAlign: "left",
                  color: "white",
                  backgroundColor: "#18a3a0",
                }}
              >
                {t("")}
              </th>
              {headerGroups.map((headerGroup, index) => (
                <React.Fragment key={index}>
                  {headerGroup.headers.map((column, index) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      style={headerTableHeadStyle}
                      key={index}
                    >
                      {column.render("Header")}
                      {!column.disableSortBy &&
                        (column.isSorted ? (
                          column.isSortedDesc ? (
                            <Sortdownarrow />
                          ) : (
                            <Sortuparrow />
                          )
                        ) : (
                          <Sortingarrow />
                        ))}
                      {enableColumnFilters && column.canFilter && (
                        <div>{column.render("Filter")}</div>
                      )}
                    </th>
                  ))}
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length > 0 ? (
              page.map((row, i) => {
                prepareRow(row);
                const isExpanded = expandedRowIds[row.id];

                return (
                  <React.Fragment key={row.id}>
                    <tr {...row.getRowProps()}>
                      <td style={{ textAlign: "left" }}>
                        <span
                          onClick={() => toggleRowExpansion(row.id)}
                          style={{ cursor: "pointer", fontSize: "18px" }}
                        >
                          {isExpanded ? "-" : "+"}
                        </span>
                      </td>
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          key={cell.column.id}
                          style={{ textAlign: "left" }}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                    {isExpanded && renderExpandedRow(row)}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length + 1} className="no-data-text">
                  No data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Region Details Modal */}
        <Modal
          show={showRegionModal}
          onHide={handleRegionModalClose}
          dialogClassName="custom-modal"
          centered
          style={{
            borderRadius: "20px",
            border: "none",
            // top: "20%",
          }}
        >
          <Modal.Header
            style={{
              backgroundColor: theme === "light" ? "#2b6591" : "#1c2038",
              color: "white",
              borderBottom: "none",
            }}
          >
            <Modal.Title style={{ color: "white" }}>Region Details</Modal.Title>
            <XCircleblack
              onClick={handleRegionModalClose}
              width="1.5em"
              height="1.5em"
              className="cursor-pointer"
            />
          </Modal.Header>
          <Modal.Body
            style={{
              backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48",
              color: theme === "light" ? "#001b30" : "white",
              border: "none",
              padding: "20px",
              lineHeight: "1.8",
              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
              maxHeight: "400px",
              overflowY: "auto",
            }}
          >
            <p>{selectedRegion?.split(",").map(s => s.trim()).join(", ")}</p>
          </Modal.Body>
          <Modal.Footer
            style={{
              backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48",
              color: "white",
              borderTop: "none",
            }}
          >
            <Button
              variant="secondary"
              onClick={handleRegionModalClose}
              style={{
                backgroundColor: theme === "light" ? "#2b6591" : "#252b48",
                borderColor: "#003366",
                borderRadius: "5px",
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
  show={showActionModal}
  onHide={handleActionModalClose}
  dialogClassName="custom-modal"
  centered
  style={{ borderRadius: "20px", border: "none" }}
>
  <Modal.Header
    style={{
      backgroundColor: theme === "light" ? "#2b6591" : "#1c2038",
      color: "white",
      borderBottom: "none",
    }}
  >
    <Modal.Title style={{ color: "white" }}>Full Action Message</Modal.Title>
    <XCircleblack
      onClick={handleActionModalClose}
      width="1.5em"
      height="1.5em"
      className="cursor-pointer"
    />
  </Modal.Header>
  <Modal.Body
    style={{
      backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48",
      color: theme === "light" ? "#001b30" : "white",
      border: "none",
      padding: "20px",
      lineHeight: "1.8",
      wordBreak: "break-word",
      whiteSpace: "pre-wrap",
      maxHeight: "400px",
      overflowY: "auto",
    }}
  >
    <p>{selectedAction}</p>
  </Modal.Body>
  <Modal.Footer
    style={{
      backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48",
      color: "white",
      borderTop: "none",
    }}
  >
    <Button
      variant="secondary"
      onClick={handleActionModalClose}
      style={{
        backgroundColor: theme === "light" ? "#2b6591" : "#252b48",
        borderColor: "#003366",
        borderRadius: "5px",
      }}
    >
      Close
    </Button>
  </Modal.Footer>
</Modal>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        {!disbalePaginationFilter2 && (
          <div className="float-start m-2 mt-2 ms-3">
            {showRowCount && (
              <div className="float-start m-2 mt-1 ms-3 pagecount-style">
                {t("showingentriestable.showing")} {translatedStartIndex}{" "}
                {t("showingentriestable.to")} {translatedEndIndex}{" "}
                {t("showingentriestable.of")} {translatedRowCount}{" "}
                {t("showingentriestable.entries")}
              </div>
            )}
          </div>
        )}
        <div className="pagination">
          {!disbalePaginationFilter && (
            <div className="d-flex">
              <span className="pagination_gotopage">
                Go to page:
                <input
                  type="number"
                  min="1"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    let pageNumber = Number(e.target.value);
                    if (pageNumber < 1 || isNaN(pageNumber)) {
                      pageNumber = 1;
                    }
                    gotoPage(pageNumber - 1);
                  }}
                  className="pagination_gotopage-input"
                />
              </span>
              <span>
                <select
                  className="pagination_select"
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  {[10, 50, 100, 500, 1000, 2000].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      show {pageSize}
                    </option>
                  ))}
                </select>
              </span>
            </div>
          )}
          {!disbalePaginationFilter1 && (
            <>
              <button
                className="pagebtn mx-2"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"<"}
              </button>
              <button className="pagination_page">
                {translateNumber(pageIndex + 1)}{" "}
              </button>
              <button
                className="pagebtn"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                {">"}
              </button>{" "}
              <span className="right_pageno">
                {t("pagination.page_of", {
                  page: translateNumber(pageIndex + 1),
                  total: translateNumber(pageOptions.length),
                })}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Expandaletable;